/**
 * External dependencies
 */
import { map, assign } from 'lodash';

/**
 * Internal dependencies
 */
import getDashboardLayout from './get-dashboard-layout';

export default (state) => {
	const layout = getDashboardLayout(state) || {};
	return map(layout.items, ({ id, position }) => ({
		i: id,
		...assign(
			{
				w: 6,
				h: 6,
				y: Infinity,
				x: 0,
			},
			{},
			position,
		),
	}));
};
